import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const QuestionOuterContainer = styled.div`
  width: 100%;
  padding: 10px 20px 10px 20px;
  @media print {
    padding-top: 0;
  }
`;

export const QuestionContainer = styled.div`
  padding: 30px;
  box-shadow: 0 2px 5px rgb(0 0 0 / 30%);
  position: relative;

  @media print {
    border: 1px solid #dee2e6;
  }
`;

export const UpperLeftCornerContainer = styled.section`
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const QuestionIndexAndCategory = styled.div`
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 1px;
  height: 23px;
  display: inline-block;
  line-height: 23px;
  text-align: center;
  white-space: nowrap;
  font-size: 11px;
  border-radius: 0 0 5px 0;
  padding: 0 7px;
  font-style: normal;
  font-weight: bold;
  text-shadow: 0 1px 0 rgb(0 0 0 / 50%);
`;

export const DifficultyNameContainer = styled.div`
  position: absolute;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 1px;
  height: 23px;
  display: inline-block;
  line-height: 23px;
  text-align: center;
  font-size: 11px;
  border-radius: 0 0 0 5px;
  padding: 0 7px;
  font-style: normal;
  font-weight: bold;
  text-shadow: 0 1px 0 rgb(0 0 0 / 50%);
  right: 0;

  ${(props) =>
    props.level === 'very_hard' &&
    css`
      background: #c65853;
    `}

  ${(props) =>
    props.level === 'hard' &&
    css`
      background: #e28b50;
    `}

    ${(props) =>
    props.level === 'medium' &&
    css`
      background: #fdbd4c;
    `}

    ${(props) =>
    props.level === 'easy' &&
    css`
      background: #bec259;
    `}

    ${(props) =>
    props.level === 'very_easy' &&
    css`
      background: #7ec666;
    `}
`;

export const TimeSpentContainer = styled.span`
  display: flex;
  flex-direction: column;
  gap: 5px;
  @media (max-width: 1030px) {
    flex-direction: row;
  }
  @media print {
    flex-direction: column;
  }
`;

export const TimeCornerDisplay = styled.div`
  margin-left: 5px;
  color: ${colors.gray2};
  font-size: 13px;
  font-weight: bold;
`;

export const TimeAwayDisplay = styled.div`
  margin-left: 5px;
  color: ${colors.red};
  font-size: 13px;
  font-weight: bold;
`;

export const EventIcon = styled.i.attrs({ className: (props) => `${props.className}` })`
  background: ${colors.red};
  color: white;
  border-radius: 0 15px 15px 0;
  line-height: 23px;
  width: 27px;
  font-size: 11px;
  padding: 0 7px;
  font-style: normal;
  font-weight: bold;
`;

export const OptionCopiedIcon = styled.i.attrs({ className: 'fa fa-clone' })`
  top: 7px;
  position: absolute;
  right: 25%;
  opacity: 0.8;
  font-size: 14px;
  color: ${colors.darkGray};
`;

export const EditButton = styled.a`
  position: absolute;
  right: 0;
  bottom: 0;
  color: ${colors.fsCyan};
  border: 1px solid ${colors.fsCyan};
  padding: 2px 7px 2px 7px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  :hover {
    background: ${colors.fsCyan};
    color: white;
    border: 1px solid ${colors.fsCyan};
  }

  @media print {
    display: none;
  }
`;

export const QuestionsAndOptionsContainer = styled.div`
  padding: 20px 0 10px 0;
  max-width: 850px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  @media (max-width: 736px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const QuestionValue = styled.div`
  p {
    font-weight: bold;
    line-height: 1.6;
    font-size: 14px;
  }
  img {
    width: auto !important;
    max-width: 100% !important;
    height: auto !important;
    max-height: 190px;
  }
  code {
    white-space: pre-wrap;
  }
`;

export const AnswersValue = styled.div`
  text-align: right;
  max-width: 425px;
  overflow-wrap: break-word;

  @media (max-width: 736px) {
    max-width: 250px;
    overflow-wrap: break-word;
  }
`;

export const OptionContainer = styled.span`
  display: inline;
  padding: 0px;
  p {
    padding: 0;
    margin: 0;
    line-height: inherit;
    font-size: 12px;
    font-weight: inherit;
  }

  img {
    max-width: 100% !important;
    height: auto !important;
    max-height: 190px;
    width: auto !important;
    image-rendering: -webkit-optimize-contrast;
  }

  code {
    white-space: pre-wrap;
    padding: 0.2rem 0.4rem;
    font-size: 90%;
    color: #bd4147;
    background-color: #f7f7f9;
    border-radius: 0.25rem;
  }
`;

export const OptionAndAnsweredContainer = styled.div`
  display: block;
  background: #ebebee;
  border-radius: 3px;
  color: #333;
  padding: 6px;
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  position: relative;
  :first-child {
    margin-top: 0px;
  }
  ${(props) =>
    props.isInductiveTest &&
    css`
      display: inline-block;
      margin: 5px;
      width: 125px;
      height: 125px;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: top;
      text-align: center;

      img {
        margin-top: 5px;
        height: 80px !important;
        width: 80px !important;
      }

      :first-child {
        margin-top: 5px;
      }
    `}

  ${(props) =>
    props.isCorrect === true &&
    css`
      background: #7ec666;
      color: white;
    `}

  ${(props) =>
    props.isWrong === true &&
    css`
      background: #c65853;
      color: white;
    `}
`;

export const AnsweredComponent = styled.span`
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 3px;
  height: 23px;
  line-height: 23px;
  text-align: center;
  font-size: 11px;
  padding: 0 7px;
  margin-top: 0 !important;
  margin-left: 4px;
  min-width: 90px;
  display: initial;
  float: right;
`;

export const SkillTag = styled.div`
  span {
    color: #fff;
    background-color: ${colors.fsCyan};
    display: flex;
    border-radius: 4px;
    text-transform: capitalize;
    width: auto;
    font-size: 14px;
    margin: 5px;
    padding: 0 2px;
    line-height: 20px;
    float: left;
    cursor: pointer;
    min-width: 60px;
    display: inline;
    padding: 2px 5px 2px 5px;
    font-size: 12px;
  }

  .experience {
    position: relative;
    color: ${colors.fsCyan};
    background-color: #fff;
    min-width: 10px;
    padding: 0 4px;
    font-size: 11px;
    font-weight: 600;
    border-radius: 10px;
    float: right;
    height: 100%;
    margin: 0;
    margin-left: 3px;
  }
`;

export const QuestionAndSkillComponent = styled.div``;

export const TestCodeButton = styled.a`
  right: 0;
  bottom: 0;
  color: ${colors.fsCyan};
  border: 1px solid ${colors.fsCyan};
  padding: 2px 7px 2px 7px;
  border-radius: 3px;
  margin: 0 5px 0 5px;
  font-size: 12px;
  cursor: pointer;
  :hover {
    background: ${colors.fsCyan};
    color: white;
  }

  @media print {
    display: none;
  }
`;

export const CodeWrittenText = styled.span`
  font-size: 15px;
  font-weight: 600;
`;

export const CodeContainer = styled.div`
  padding: 5px;
  font-size: 14px;

  code {
    white-space: pre-wrap !important;
  }

  /* Remove line numbers added by SyntaxHighlighter, they are necessary for lineProps pasted input highlight to work */
  .react-syntax-highlighter-line-number {
    display: none !important;
  }

  pre {
    padding: 0px !important;
    overflow-x: hidden !important;
  }

  @media print {
    pre {
      border: 0;
      page-break-inside: auto;
    }
  }
`;

export const FlexParent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  ${(props) =>
    props.isLongPastedTimeline &&
    css`
      padding-bottom: 25px;
    `}

  @media print {
    page-break-inside: avoid;
    padding-top: 15px;
  }
`;

export const InputFlexContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 140px;
  max-width: 100%;
  position: relative;
  z-index: 0;

  @media (max-width: 900px) {
    width: 600px;
  }
  @media (min-width: 901px) {
    width: 800px;
  }

  ${(props) =>
    props.isLongPastedTimeline &&
    css`
      flex-wrap: wrap;
      justify-content: start;
      height: 160px;
    `}
`;

export const TimelineContainer = styled.div``;

export const Timeline = styled.div`
  width: 25px;
  height: 25px;
  background-color: ${colors.darkGray3};
  position: relative;
  border-radius: 50%;

  :hover {
    cursor: pointer;
  }

  ::before,
  ::after {
    width: calc(800px / ${(props) => props.numDots});
    content: '';
    display: block;
    position: absolute;
    z-index: -1;
    top: 50%;
    transform: translateY(-50%);
    background-color: ${colors.darkGray3};
    height: 5px;
  }

  span {
    visibility: visible;
    position: absolute;
    left: 50%;
    ::before,
    ::after {
      visibility: visible;
      position: absolute;
      left: 50%;
    }
  }

  ::before {
    left: calc(calc(-800px / ${(props) => props.numDots}) + calc(25px / 2));
  }

  ::after {
    right: calc(calc(-800px / ${(props) => props.numDots}) + calc(25px / 2));
  }

  ${(props) =>
    props.active &&
    css`
      background-color: ${colors.darkGray3};
      ::before {
        background-color: ${colors.darkGray3};
      }
      ::after {
        background-color: ${colors.gray5};
      }
      span {
        font-weight: 700;
        color: #424949;
      }
    `}

  ${(props) =>
    props.inactive &&
    css`
      background-color: ${colors.gray5};
      ::before {
        background-color: ${colors.gray5};
      }
      ::after {
        background-color: ${colors.gray5};
      }
    `}

    ${(props) =>
    props.beforeActive &&
    css`
      background-color: ${colors.darkGray3};
      ::before {
        background-color: ${colors.darkGray3};
      }
      ::after {
        background-color: ${colors.darkGray3};
      }
    `}

    ${(props) =>
    props.finalSubmit &&
    css`
      ::after {
        visibility: hidden;
      }
    `}

    ${(props) =>
    props.lastPastedInput &&
    css`
      ::after {
        visibility: hidden;
      }
    `}

    ${(props) =>
    props.isLongPastedTimeline &&
    css`
      margin-left: 12px;
      margin-right: 12px;
    `}
`;

export const TimelineDot = styled.span`
  ${(props) =>
    props.timeOfRun &&
    css`
      ::before {
        content: '${(props) => props.timeOfRun}';
        top: 30px;
        transform: translateX(-50%) rotateZ(-45deg);
        font-size: 14px;
        top: 35px;
      }
    `}
  ${(props) =>
    props.scoreOfRun &&
    css`
      ::after {
        content: '${(props) => props.scoreOfRun}';
        top: -55px;
        width: 60px;
        transform: translateX(-5px) rotateZ(-45deg);
        font-size: 12px;
        text-indent: -10px;
      }
    `};
`;

export const InputBestRun = styled.span`
  visibility: visible;
  position: absolute;
  left: 50%;
  top: -80px;
  width: 70px;
  transform: translateX(-5px) rotateZ(-45deg);
  font-size: 12px;
  text-indent: -35px;
`;

export const DescriptionText = styled.div`
  font-size: 14px;
`;

export const BoldText = styled.div`
  font-weight: 600;
`;

export const OvertimeTextDescription = styled.div`
  display: flex;
  align-items: baseline;
  margin-top: 15px;
`;

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-flex;
  vertical-align: middle;
`;

export const DropdownMenuContainer = styled.div`
  position: absolute;
  max-height: 400px;
  overflow: auto;
  z-index: 1000;
  min-width: 13rem;
  padding: 0.5rem 0;
  font-size: 1rem;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  left: 5px;
  top: 40px;
`;

export const DropdownItem = styled.a`
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #555555;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  text-decoration: none;
  :hover {
    text-decoration: none;
    color: #212529;
    background-color: #f5f5f5;
  }
`;

export const Divider = styled.div`
  height: 1px;
  margin: 0.5rem 0;
  overflow: hidden;
  background-color: #e5e5e5;
`;

export const LabelAndCheckboxContainer = styled.div`
  margin-top: 8px;
  display: flex;
  padding-left: 25px;
  cursor: pointer;
`;

export const InputCheckbox = styled.input`
  height: 17px;
  width: 17px;
  cursor: pointer;
  margin-top: 3px;
`;

export const Label = styled.label`
  margin-left: 8px;
  margin-bottom: 0px;
  color: #373a3c;
  font-size: 15px;
`;

export const NoTextAnswer = styled.div`
  font-style: italic;
  text-align: left;
`;

export const GraphContainer = styled.div`
  height: 400px;
  width: 100%;
`;
export const GraphContainerSmall = styled.div`
  height: 70px;
  width: 100%;
`;

export const TimeAwayGraphContainer = styled.div`
  height: 110px;
  width: 100%;
`;

export const CopiedTextContainer = styled.div`
  font-size: 14px;
  white-space: break-spaces;
`;
